import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './edit-finding-comment-dialog.controller';
import template from './edit-finding-comment-dialog.html';
import nameTpl from '../messages/finding.name.messages.html';


class dialogService {
  getOptions($event, { findingId, findingCommentId, findingCommentText }) {
    return {
      controller,
      controllerAs: 'editFindingCommentDialogVM',
      locals: {
        findingId,
        findingCommentId,
        findingCommentText
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.editFindingCommentDialog', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('editFindingCommentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('finding.name.messages.html', nameTpl);
  })
  .name;
